export const ListQueryKey = 'recommendCodes';
export const DetailQueryKey = 'recommendCode';
export const Urls = {
  selectUrl: '/code/list',
  updateUrl: '/code/update',
  deleteUrl: '/code/delete',
  createUrl: '/code/create',
  detailUrl: '/code/detail'
};